/*
Documentation

*** make sure to declare all action types in actions.js one folder level back

*/

import * as actionTypes from '../../actions';

const initialState = {
    template_emails: [],
    total: 0,
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.SET_TEMPLATE_EMAILS:

            return {
                ...state,
                template_emails: action.payload.data,
                total: action.payload.total_documents,
            }

        default: return state;

    }

}

export default reducer;
